/* =====================================================================
   LA BANDA DE AVISO · Entrega B (20 sep 2026)
   =====================================================================
   Discreta, arriba: qué va a pasar, cuándo, cuánto dura y qué tienen que
   hacer (normalmente nada). Se puede cerrar y VUELVE cuando falte 1 h:
   el cierre se guarda por (mantenimiento, fase), así que cerrar «lejos» no
   apaga «última hora». Sin nada programado no pinta nada. La monta el
   integrador en `AppShell`, delante de los demás avisos.
   ===================================================================== */
import { useState } from 'react';
import { useMantenimiento, estaCerrada, cerrar, cuandoEnPalabras } from './mantenimiento';

export default function BandaMantenimiento() {
  const { programado, fase } = useMantenimiento();
  const [cerradaAhora, setCerradaAhora] = useState(null);
  if (!programado || !fase || fase === 'terminado') return null;
  // En curso o pasado del estimado, la que habla es la pantalla (si la API
  // no contesta) o esta misma banda en tono más fuerte (si sí contesta).
  const enCurso = fase === 'en_curso' || fase === 'pasado';
  if (!enCurso && (estaCerrada(programado, fase) || cerradaAhora === fase)) return null;
  const minutos = Number(programado.duracion_min) || 10;
  return (
    <div role="status" data-banda="mantenimiento" data-fase={fase}
         className={(enCurso ? 'bg-amber-200 border-amber-400 ' : 'bg-amber-50 border-amber-200 ')
           + 'text-amber-900 border-b text-sm px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1'}>
      <span className="font-semibold">{enCurso ? 'Mantenimiento en curso.' : fase === 'ultima_hora' ? 'En menos de una hora:' : 'Aviso de mantenimiento.'}</span>
      <span className="flex-1 min-w-[12rem]">{programado.texto}</span>
      <span className="text-xs opacity-80">
        {cuandoEnPalabras(programado.inicio)} · unos {minutos} min
      </span>
      {!enCurso && (
        <button type="button"
                className="text-xs underline underline-offset-2 hover:no-underline"
                onClick={() => { cerrar(programado, fase); setCerradaAhora(fase); }}
                aria-label="Cerrar este aviso; volverá cuando falte una hora">
          Cerrar
        </button>
      )}
    </div>
  );
}
